import m from 'mithril';

import { InputGroup, SelectionGroup, Option } from "../BootstrapForm"
import MessageProvider from '../../../MessageProvider';
import {Dialog, SvgIcon} from "../MaterialDesignComponents";
import { GenderType, GuestInfo } from '../../../Models';

interface Attrs {
    messageProvider: MessageProvider,
    presetCountryCode: string|null,
    totalAdultsOfRoomsSelected: number,
    totalChildrenOfRoomsSelected: number,
    restartUrl?: string,
    onSubmit: (guest: GuestInfo, totalAdults: number, totalChildren: number, specialRequest:string) => void    
}

interface GuestDetailsFormModel {
    name:string;
    email:string;
    phoneNumber:string;
    gender:GenderType;
    countryCode:string;
    specialRequest:string;
    totalAdult: number;
    totalChild: number;
}

export default function GuestDetailsForm(): m.Component<Attrs> {
    let showingDeleteRecentGuestInfoDialog = false;
    let deleteRecentGuestIndex = 0;
    let recentGuestInfos:GuestDetailsFormModel[] = []
    let showingGuestForm: boolean = false
    let saveGuestInfo = false;
    let isIneligibleCountryCodeSelected = false;
    let deleteGuestInfoDescription:string = "";

    //TODO we can load this initial info from the local storage
    let guestFormModel: GuestDetailsFormModel = {
        name : "",
        email: "",
        phoneNumber: "",
        gender: GenderType.MALE,
        countryCode: "",
        specialRequest: "",
        totalAdult: 0,
        totalChild: 0
    };

    let countryOptions:Option[] = buildCountryOptions(getCountryCodes());
    let totalAdultOptions: Option[] = [];
    let totalChildrenOptions: Option[] = [];
    let isDirty:boolean = false;

    return {
        oncreate(vnode) {
            if(vnode.attrs.presetCountryCode != null) {
                let countryCode:string = vnode.attrs.presetCountryCode;
                guestFormModel.countryCode = countryCode.toLocaleUpperCase();
            } 
        },

        oninit(vnode) {
            if(localStorage.getItem('recentGuestInfos') != null){
                recentGuestInfos = JSON.parse(localStorage.getItem("recentGuestInfos") || 'false');
            }else{
                showingGuestForm = true;
            }

            totalAdultOptions = buildAdultsOptions(vnode.attrs.totalAdultsOfRoomsSelected);
            totalChildrenOptions = buildChildrenOptions(vnode.attrs.totalChildrenOfRoomsSelected);            
        },
        view(vnode) {
            const {messageProvider, presetCountryCode, restartUrl, onSubmit} = vnode.attrs;
            
            return [
                (!showingGuestForm && recentGuestInfos.length > 0)?
                [
                    m("div.d-flex pb-3", [
                        m("div", [
                            m("div", messageProvider.get("guest_info"))
                        ]),
                        m("div.ml-auto", m("button.btn btn-sm btn-outline-primary rounded", {
                            onclick:(event) => {
                                event.preventDefault()
                                showingGuestForm = true;
                            }
                        }, messageProvider.get("create_new")))
                    ]),
                    m("div.card", [
                        m("ul.list-group list-group-flush", [
                            recentGuestInfos.map((recentGuestInfo,index) => {
                                return m("li.list-group-item", [
                                    m("div.d-flex align-items-center", [
                                        m("div.mr-auto", [
                                            m("div", recentGuestInfo.name),
                                            m("small.text-muted", recentGuestInfo.phoneNumber)
                                        ]),
                                        m("div.mr-2", m("button.btn btn-sm btn-outline-danger rounded", {
                                            onclick:(event) => {
                                                event.preventDefault()
                                                showingDeleteRecentGuestInfoDialog = true;
                                                deleteRecentGuestIndex = index;
                                                deleteGuestInfoDescription = recentGuestInfos[index].name + " ( " + recentGuestInfos[index].phoneNumber + " ) ";
                                            }
                                        }, messageProvider.get("delete"))),
                                        m("div", m("button.btn btn-sm btn-outline-primary rounded", {
                                            onclick:(event) => {
                                                event.preventDefault()
                                                guestFormModel.name = recentGuestInfo.name
                                                guestFormModel.phoneNumber = recentGuestInfo.phoneNumber
                                                guestFormModel.email = recentGuestInfo.email
                                                guestFormModel.specialRequest = recentGuestInfo.specialRequest
                                                guestFormModel.countryCode = recentGuestInfo.countryCode
                                                showingGuestForm = true;
                                                
                                                if(presetCountryCode != null) {
                                                    isIneligibleCountryCodeSelected = 
                                                        (presetCountryCode != guestFormModel.countryCode);
                                                }else{
                                                    isIneligibleCountryCodeSelected = guestFormModel.countryCode == 'MM'
                                                }
                                            }
                                        }, messageProvider.get("reuse")))
                                    ] )
                                ])
                            })
                        ])
                    ]),
                    m(Dialog, {
                        isOpen: showingDeleteRecentGuestInfoDialog,
                        onClose : () => {
                            showingDeleteRecentGuestInfoDialog = false;
                        },
                        actionItems : [
                            {
                                label: "Cancel",
                                onclick: () => {
                                    showingDeleteRecentGuestInfoDialog = false;
                                }
                            },
                            {
                                label: "Ok",
                                onclick: () => {
                                    showingDeleteRecentGuestInfoDialog = false;
                                    recentGuestInfos.splice(deleteRecentGuestIndex, 1);
                                    window.localStorage.setItem('recentGuestInfos', JSON.stringify(recentGuestInfos));
                                }
                            }
                        ]
                    }, [
                        m("div.text-center", 
                            m(SvgIcon, {
                            iconType: "warning",
                            colorScheme: "warning",
                            sizeScheme: "largest"
                            })
                        ),
                        m("div", {class:"mb-1"},
                            messageProvider.interpolate(
                                "warning_delete_recent_guest_info", {
                                guest_info: deleteGuestInfoDescription
                            }) 
                        )
                    ])
                ]:

                m("form.guest-details-form", {id:"guest-details-form"}, [
                    m(InputGroup, {
                        label: messageProvider.get("name"),
                        name: "name",
                        initialValue: guestFormModel.name,
                        required: true,
                        onValueChange: (newValue:string) => {
                            guestFormModel.name = newValue;
                        }
                    }),

                    m(InputGroup, {
                        label: messageProvider.get("phone_number"),
                        name: "phoneNumber",
                        id: "phoneNumber",
                        initialValue: guestFormModel.phoneNumber,
                        required: true,
                        pattern: "^09[0-9]{6,10}$",
                        placeholder: "09 _ _ _ _ _ _ _", 
                        type: 'tel',                       
                        instruction: messageProvider.get("require_myanmar_ph_number"),
                        maxlength: 16, // there could be extra stuffs when copy and paste
                        inputmode:'number',
                        onValueChange: (phoneNumber:string) => {
                            var newValue = phoneNumber.replace(new RegExp(/[^\d]/, 'ig'), "");
                            guestFormModel.phoneNumber = newValue;
                        },
                        onFocus: (phoneNumber:string)=>{
                            isValidPhoneNumber(phoneNumber);
                        },
                    }),

                    m(InputGroup, {
                        label: messageProvider.get("email"),
                        name: "email",
                        type: "email",
                        inputmode:"email",
                        pattern: "^.*[\.]{1}[a-zA-Z]{2,6}$",
                        initialValue: guestFormModel.email,
                        onValueChange: (newValue:string) => {
                            guestFormModel.email = newValue;
                        }
                    }),   
                    
                    m(SelectionGroup, {
                        label: messageProvider.get("country_of_origin"),
                        name: "country",
                        value: guestFormModel.countryCode,
                        required: true,
                        options: countryOptions,
                        hasEmptyOption: true,
                        onValueChange: (newValue:string) => {
                            console.log("Country code selected:", newValue);
                            guestFormModel.countryCode = newValue;

                            if(presetCountryCode != null) {
                                isIneligibleCountryCodeSelected = 
                                    (presetCountryCode != guestFormModel.countryCode);
                            }else{
                                isIneligibleCountryCodeSelected = guestFormModel.countryCode == 'MM'
                            }
                        }
                    }),

                    (isIneligibleCountryCodeSelected)?
                    m("div.alert alert-danger", 
                        m("small", (presetCountryCode != null)? messageProvider.get("room_rates_only_for_local"): messageProvider.get("room_rates_only_for_foreigner")),
                        (restartUrl)?
                        m("div.mt-4", 
                            m("small", 
                                m("a", {href: restartUrl}, messageProvider.get("restart_for_foreigner"))
                            )
                        ): null
                    ):null,

                    m("div.row", [
                        m("div.col", [
                            m(SelectionGroup, {
                                label: messageProvider.get("total_adults"),
                                name: "totalAdults",
                                value: guestFormModel.totalAdult + "",
                                options: totalAdultOptions,
                                hasEmptyOption: true,
                                required: true,
                                onValueChange: (newValue:string) => {
                                    guestFormModel.totalAdult = parseInt(newValue); 
                                }
                            }),
                        ]),
                        m("div.col", [
                            m(SelectionGroup, {
                                label: messageProvider.get("total_children"),
                                name: "totalChildren",
                                value: guestFormModel.totalChild + "",
                                options: totalChildrenOptions,
                                hasEmptyOption: true,
                                onValueChange: (newValue:string) => {
                                    guestFormModel.totalChild = parseInt(newValue); 
                                }
                            }),
                        ]),
                    ]),

                    m(InputGroup, {
                        label: messageProvider.get("special_request"),
                        name: "specialRequest",
                        placeholder: messageProvider.get("special_request_hint"),
                        initialValue: guestFormModel.specialRequest,
                        //instruction: "Please write a short description.",
                        onValueChange: (newValue:string) => {
                            console.log("Special request:", newValue);
                            guestFormModel.specialRequest = newValue;
                        }
                    }),

                    m("div.mb-2", [
                        m("div.d-flex align-items-center pt-3 pb-2", {
                            onclick: () => {
                                saveGuestInfo = !saveGuestInfo;
                            }
                        }, [
                            m("div.text-primary", m("small", m("i", {class: (!saveGuestInfo)? "bi bi-square": "bi bi-check-square-fill"}))),
                            m("div.px-2", [
                                m("small", messageProvider.get("save_guest_info"))
                            ])
                        ])
                    ]),

                    m("div.mt-3", {style:"_margin-top:96px"}, 
                        m("div._fixed-bottom", 
                            (!isDirty)?
                            m("button.mt-4 mb-3 btn btn-primary btn-block rounded", {
                                type: "submit",
                                class : (isIneligibleCountryCodeSelected)? "disabled" : "",
                                onclick: (event:Event) => {
                                    event.preventDefault();

                                    if(isIneligibleCountryCodeSelected) {
                                        return;
                                    }

                                    // https://developer.mozilla.org/en-US/docs/Learn/Forms/Form_validation
                                    let form = <HTMLFormElement> document.getElementById("guest-details-form");
                                    if(form!=null) {
                                        form.reportValidity();
        
                                        let formIsValid = form.checkValidity();
                                        if(formIsValid) {
                                            let guestInfo:GuestInfo = {
                                                name: guestFormModel.name,
                                                emailAddress: guestFormModel.email,
                                                cellPhoneNumber: guestFormModel.phoneNumber,
                                                countryCode: guestFormModel.countryCode,
                                                gender: GenderType.MALE
                                            }
                                            let isEqualInfo = false;
                                            isDirty = true;

                                            if(saveGuestInfo){
                                                for(var i=0; i<recentGuestInfos.length; i++){
                                                    if(recentGuestInfos[i].name == guestFormModel.name || recentGuestInfos[i].phoneNumber == guestFormModel.phoneNumber){
                                                        isEqualInfo = true;
                                                        
                                                        if(recentGuestInfos[i].name != guestFormModel.name 
                                                        || recentGuestInfos[i].phoneNumber != guestFormModel.phoneNumber
                                                        || recentGuestInfos[i].email != guestFormModel.email 
                                                        || recentGuestInfos[i].specialRequest != guestFormModel.specialRequest
                                                        || recentGuestInfos[i].countryCode != guestFormModel.countryCode){
                                                            recentGuestInfos[i].name = guestFormModel.name
                                                            recentGuestInfos[i].phoneNumber = guestFormModel.phoneNumber
                                                            recentGuestInfos[i].email = guestFormModel.email
                                                            recentGuestInfos[i].specialRequest = guestFormModel.specialRequest
                                                            recentGuestInfos[i].countryCode = guestFormModel.countryCode
                                                        }
    
                                                        break;
                                                    } 
                                                }

                                                if(saveGuestInfo && !isEqualInfo){
                                                    recentGuestInfos.push(guestFormModel);
                                                }
                                                window.localStorage.setItem('recentGuestInfos', JSON.stringify(recentGuestInfos));
                                            }

                                            showingGuestForm = true;

                                            onSubmit(guestInfo, guestFormModel.totalAdult, guestFormModel.totalChild, guestFormModel.specialRequest);
                                            
                                        } 
                                    }
                                }
                            }, messageProvider.get("submit")):
                            m("button.mt-4 mb-3", {
                                "type":"button",
                                class:"btn btn-primary btn-block d-flex align-items-center justify-content-center rounded",
                                disabled: true
                            }, [
                                m("span", {
                                    "role":"status",
                                    class:"spinner-border spinner-border-sm mr-1"
                                }),
                                m("span",  messageProvider.get("submit"))
                            ])
                        )
                    )
                ])
            ]
        }
    }
}

function isValidPhoneNumber(phoneNumber:String){
    let phoneNumberElem = document.getElementById('phoneNumber');
    if(phoneNumberElem != null) {
        phoneNumberElem.addEventListener('input', function (e:any) {
            var x = e.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,9})/);
            if(!x[2]) {
                e.target.value = x[1];
            } else {
                if(x[1]!='09') {
                    e.target.value = '09' + x[1] + x[2];
                } else {
                    e.target.value = '09' + x[2];
                }
            }
         });
    }
}

function getCountryCodes(): string[] {
    return [
        'AD','AE','AF','AG','AI','AL','AM','AO','AQ','AR',
        'AS','AT','AU','AW','AX','AZ','BA','BB','BD','BE',
        'BF','BG','BH','BI','BJ','BL','BM','BN','BO','BQ',
        'BR','BS','BT','BV','BW','BY','BZ','CA','CC','CD',
        'CF','CG','CH','CI','CK','CL','CM','CN','CO','CR',
        'CU','CV','CW','CX','CY','CZ','DE','DJ','DK','DM',
        'DO','DZ','EC','EE','EG','EH','ER','ES','ET','FI',
        'FJ','FK','FM','FO','FR','GA','GB','GD','GE','GF',
        'GG','GH','GI','GL','GM','GN','GP','GQ','GR','GS',
        'GT','GU','GW','GY','HK','HM','HN','HR','HT','HU',
        'ID','IE','IL','IM','IN','IO','IQ','IR','IS','IT',
        'JE','JM','JO','JP','KE','KG','KH','KI','KM','KN',
        'KP','KR','KW','KY','KZ','LA','LB','LC','LI','LK',
        'LR','LS','LT','LU','LV','LY','MA','MC','MD','ME',
        'MF','MG','MH','MK','ML','MM','MN','MO','MP','MQ',
        'MR','MS','MT','MU','MV','MW','MX','MY','MZ','NA',
        'NC','NE','NF','NG','NI','NL','NO','NP','NR','NU',
        'NZ','OM','PA','PE','PF','PG','PH','PK','PL','PM',
        'PN','PR','PS','PT','PW','PY','QA','RE','RO','RS',
        'RU','RW','SA','SB','SC','SD','SE','SG','SH','SI',
        'SJ','SK','SL','SM','SN','SO','SR','SS','ST','SV',
        'SX','SY','SZ','TC','TD','TF','TG','TH','TJ','TK',
        'TL','TM','TN','TO','TR','TT','TV','TW','TZ','UA',
        'UG','UM','US','UY','UZ','VA','VC','VE','VG','VI',
        'VN','VU','WF','WS','YE','YT','ZA','ZM','ZW'];
}

function buildCountryOptions(countryCodes:string[]): Option[] {
    var getCountryNames = new Intl.DisplayNames(['en'], {type: 'region'});
    return countryCodes.map(code => {
            return {                                
                label: getCountryNames.of(code.toLocaleUpperCase()) || "Unknown Country: " + code,
                value: code.toLocaleUpperCase()
            }
        }).sort((a, b) => a.label.localeCompare(b.label))
}

function buildAdultsOptions(totalAdultsOfRoomsSelected: number): Option [] {
    let totalAdultOptions:Option[] = [];
    for(let i=1; i <= totalAdultsOfRoomsSelected; i++){
        let adult: Option = {
            label: i.toString(), value: i.toString()
        }
        totalAdultOptions.push(adult)
    }
    return totalAdultOptions;
}

function buildChildrenOptions(totalChildrenOfRoomsSelected: number): Option[]{
    let totalChildrenOptions:Option[] = [];
    for(let i=0; i <= totalChildrenOfRoomsSelected; i++){
        let child: Option = {
            label: i.toString(), value: i.toString()
        }
        totalChildrenOptions.push(child)
    }

    return totalChildrenOptions;
}